<template>
    <div class="warp">
      <div class="content">
        <div class="contentOnePart">
          <p>
            为保障本平台司机端APP相关功能的实现与应用的稳定运行，本平台可能会接入由第三方提供服务的软件开发包（SDK）以实现相关服务目的。不同版本的第三方SDK会有所不同，详见下文。本平台会对接入的第三方进行严格的安全监测，并尽商业上的合理努力去要求这些第三方对您的个人信息采取保护措施。
          </p>
          <p class="header">一、第三方SDK列表</p>
          <p>为保障本平台司机端APP相关功能的实现与应用的稳定运行，本平台可能会接入由第三方提供服务的软件开发包（SDK）以实现相关服务目的。不同版本的第三方SDK会有所不同，详见下表。本平台会对接入的第三方进行严格的安全监测，并尽商业上的合理努力去要求这些第三方对您的个人信息采取保护措施。</p>
          <div class="partOneCont">
            <div v-for="(item, index) in thirdPartyAgreementDataFirst" :key="index" class="partOne_item">
              <p>{{ index+1 }}.SDK名称：{{ item.sdkName }}</p>
              <p v-if="item.packageNameStr">包名：{{ item.packageNameStr }}</p>
              <p>第三方名称：{{ item.thirdName }}</p>
              <p>产品类型：{{ item.productType }}</p>
              <p>使用目的：{{ item.purpose }}</p>
              <p>收集的个人信息种类：：{{ item.collectKinds }}</p>
              <p class="hrefDiv">
                <a :href="item.privacyLink" target="_blank">{{ item.privacyLinkName }}</a>
              </p>
            </div>
          </div>
        </div>
        <div class="contentTwoPart">
          <p class="header">二、第三方非SDK列表</p>
          <div class="partOneCont">
            <div v-for="(item, index) in thirdPartyAgreementDataSecond" :key="index" class="partOne_item">
              <p>{{ index+1 }}.第三方名称：{{ item.name }}</p>
              <p>数据传输类型：{{ item.transmissionType }}</p>
              <p>产品类型：{{ item.productType }}</p>
              <p>使用目的：{{ item.purpose }}</p>
              <p>收集的个人信息种类：{{ item.collectKinds }}</p>
              <p class="hrefDiv">
                <a :href="item.privacyLink" target="_blank">{{ item.privacyLinkName }}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { thirdPartyAgreementDataFirst, thirdPartyAgreementDataSecond } from "@/const/agreement";

  
  export default {
    name: 'ThridPartyAgreement',
    data() {
      return {
        thirdPartyAgreementDataFirst,
        thirdPartyAgreementDataSecond
      }
    },
    created() {
        document.title = '第三方信息共享清单'
    }
  }
  </script>
  
  <style  scoped>
  .warp {
    width: 100%;
    max-height: 100%;
    box-sizing: border-box;
    padding: 20px;
    display: flex;
    flex-direction: column;
  }
  
  .content {
    padding: 0 10px;
    font-size: 26px;
    font-weight: bold;
    margin-bottom: 20px;
    text-align: left;
  }

  .contentOnePart p, .partOne_item, .contentTwoPart p{
    min-height: 48px;
    color: rgba(0, 0, 0, 0.65);
    font-size: 28px;
    margin-bottom: 48px;
  }
  .content .header{
    margin: 0;
  }
  .partOne_item p {
    margin: 0;
  }
  </style>
  